import SearchEngineAdapter from 'Services/Adapters/SearchEngineBeta/SearchEngineAdapter';
import CompanyAdapter from 'Services/Adapters/SearchEngineBeta/CompanyAdapter';
import ContactAdapter from 'Services/Adapters/SearchEngineBeta/ContactAdapter';
import IndividualAdapter from 'Services/Adapters/SearchEngineBeta/IndividualAdapter';
import ProductAdapter from 'Services/Adapters/SearchEngineBeta/ProductAdapter';
import DocumentAdapter from 'Services/Adapters/SearchEngineBeta/DocumentAdapter';
import OpportunityAdapter from 'Services/Adapters/SearchEngineBeta/OpportunityAdapter';

/**
 * List of adapters available for archive search result
 * When a new type of archive result is avaible, add the corresponding adapter in the list
 */
const adapters = {
    CompanyAdapter,
    ContactAdapter,
    IndividualAdapter,
    ProductAdapter,
    DocumentAdapter,
    OpportunityAdapter,
};

export default class ArchivedAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'archived';
    }

    constructor(data = [], query = '') {
        super(data, query);
        this.key = ArchivedAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Archivé'),
            count: 0,
            items: [],
        };
    }

    extractDataByType() {
        return this.data ? this.data.filter((item) => item.is_archived) : [];
    }

    /**
     * Return the right adapter by comparing item.object.type to the static _key of adapters
     * If no adapter has been registered, log error for sentry and return empty object to continue execution
     */
    formatItem(item) {
        const adapter = Object.values(adapters).find(
            (adapter) => adapter._key === item.object.type,
        );

        try {
            return {
                ...new adapter(_, this.query).formatItem(item),
                resultType: item.object.type,
            };
        } catch (error) {
            console.error('[Result archived] Adapter not found', error);
            return {};
        }
    }
}
